//Fix for IE 10 and newer
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/es6/array';
import 'core-js/es7/string';
import 'raf/polyfill';

import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import store from './storeConfig'

import App from './components/App'

render(
    <Provider store={store}>
        <div>
            <App />
        </div>
    </Provider>,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js